var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B4EEB21-4152-46E8-9880-74F9E250D4A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB--DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product/Landing-Page",
    transform: "translate(-1161.000000, -9053.000000)",
    fill: "#777E90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(227.000000, 8694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQ/Closed",
    transform: "translate(0.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus-Icon",
    transform: "translate(942.142136, 48.142136) rotate(-315.000000) translate(-942.142136, -48.142136) translate(932.142136, 38.142136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58925569,4.41074451 L10,8.82148902 L14.4107445,4.41074436 C14.7361811,4.08530742 15.2638189,4.08530742 15.5892555,4.41074436 C15.9146925,4.73618125 15.9146925,5.2638188 15.5892555,5.58925569 L11.178511,10 L15.5892555,14.4107445 C15.9146925,14.7361811 15.9146925,15.2638189 15.5892555,15.5892555 C15.2638189,15.9146925 14.7361811,15.9146925 14.4107445,15.5892555 L10,11.178511 L5.58925589,15.5892555 C5.263819,15.9146925 4.7361814,15.9146925 4.41074451,15.5892555 C4.08530757,15.2638189 4.08530757,14.7361811 4.41074451,14.4107445 L8.82148902,10 L4.41074436,5.58925589 C4.08530742,5.263819 4.08530742,4.7361814 4.41074436,4.41074451 C4.73618125,4.08530757 5.2638188,4.08530757 5.58925569,4.41074451 Z",
    id: "Close-icon"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.28b65ead78c0ac50c8278c55635d7707.svg";
export { ForwardRef as ReactComponent };